import { createFilterOptionsSlice } from '@skynet/data-filter-options';
import type { FilterOptions, PersistOptions } from '@skynet/data-filter-options';

export interface DexTransactionFilterOptions {
  type: string[];
  successOnly: boolean;
  autoUpdate: boolean;
  withdraw: boolean;
  page: number;
}

export type DexTransactionFilterState = FilterOptions<DexTransactionFilterOptions>;

export const initialDexTransactionFilterOptions: DexTransactionFilterOptions = {
  type: [],
  successOnly: false,
  autoUpdate: true,
  withdraw: false,
  page: 1,
};

/**
 * Persist config for the filter slice. The app mounts the slice under
 * `dex.transactions.filter`, wraps it with `persistReducer` and its own storage,
 * and keeps this key so the persisted filters survive upgrades.
 */
export const DEX_TRANSACTION_FILTER_PERSIST_CONFIG = {
  key: 'dexTransactions/filter',
  blacklist: ['sort', 'search', 'autoUpdate', 'withdraw', 'page'],
} as const satisfies PersistOptions & { key: string };

export const dexTransactionFilterSlice = createFilterOptionsSlice<DexTransactionFilterOptions>({
  prefix: 'dexTransactions',
  initialState: initialDexTransactionFilterOptions,
  clearState: {
    type: [],
    successOnly: false,
    autoUpdate: true,
    withdraw: false,
    page: 1,
  },
});

export const dexTransactionFilterActions = dexTransactionFilterSlice.actions;
